import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogOverlay, Dropdown } from '@shopflo/ui'
import { useSupportPageContext } from 'src/lib/contexts/SupportPageContext'
import { Check, X } from 'react-feather'
import { useLocale } from 'src/lib/hooks/useLocal'
import { deleteRequest } from 'src/lib/core/api-client'
import { apiURI } from 'src/lib/utils/constants'
import { KeyedMutator } from 'swr'
import { errorToast } from 'src/lib/utils/toasters'
import { useLoader } from 'src/lib/contexts/LoaderContext'

interface DeleteTicketDialogProps {
  mutateSuggestion: KeyedMutator<any>
}

const DeleteTicketDialog: React.FC<DeleteTicketDialogProps> = ({ mutateSuggestion }) => {
  const { setLoaderProperties } = useLoader()

  const {
    state: { isDeleteTicketDialogOpen, featureSuggestionForm },
    actions: { handleSetDeleteTicketDialogOpen }
  } = useSupportPageContext()
  const { t } = useLocale()

  const handleDeleteTicket = async () => {
    if (!featureSuggestionForm.issueId) {
      return
    }
    try {
      setLoaderProperties({ isLoaderVisible: true, message: 'Deleting' })
      const response = await deleteRequest(`/feedback/${featureSuggestionForm.issueId}`, apiURI.SETTLEMENT_ENGINE)
      if (!response.error) handleSetDeleteTicketDialogOpen(false)

      mutateSuggestion()
    } catch (err: any) {
      //handle error
      errorToast('')
      console.error(err)
    } finally {
      setLoaderProperties({ isLoaderVisible: false })
    }
  }
  return (
    <Dialog open={isDeleteTicketDialogOpen} onOpenChange={() => handleSetDeleteTicketDialogOpen(false)}>
      <DialogOverlay className='fixed inset-0 bg-black/50 z-40' />
      <DialogContent className='sm:max-w-[520px] bg-white text-black z-50 fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-2xl'>
        <DialogHeader>
          <DialogTitle>
            <div className='flex justify-between items-start'>
              <p className='text-lg font-semibold text-left'>{t('support.delete_feature_alert_message')}</p>
              <X onClick={() => handleSetDeleteTicketDialogOpen(false)} className='cursor-pointer shrink-0 ml-4' />
            </div>
          </DialogTitle>
        </DialogHeader>

        <div className='py-3'>
          <p>{t('support.delete_warning_message')}</p>
        </div>

        <DialogFooter>
          <div className='flex justify-end gap-3'>
            <button
              onClick={() => handleSetDeleteTicketDialogOpen(false)}
              className='px-3 py-2 bg-white text-coal-dark rounded-md border-1 border-coal-lighter cursor-pointer text-sm font-semibold'
            >
              {t('close')}
            </button>
            <button
              type='submit'
              className='px-3 py-2 bg-red-500 hover:bg-red-600 cursor-pointer flex gap-2 items-center rounded-lg'
              onClick={handleDeleteTicket}
            >
              <span className='text-sm font-semibold text-white'>{t('delete_request')}</span>
            </button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteTicketDialog
